"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "default", {
    enumerable: true,
    get: function() {
        return _default;
    }
});
var _jsxruntime = require("react/jsx-runtime");
var _core = require("@mantine/core");
var _titlemodulecss = /*#__PURE__*/ _interop_require_default(require("../../../dist/assets/components/title.module.css"));
function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function _interop_require_default(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var Title = function(props) {
    var order = props.order || 1;
    return /*#__PURE__*/ (0, _jsxruntime.jsx)(_core.Title, _extends({}, props, {
        style: _extends({}, props.style),
        className: _titlemodulecss.default["title-" + order]
    }));
};
var _default = Title;
